<template>
    <div class="text-center">
        <h2 class="mb-4">
            Page not found!
        </h2>

        <div class="links">
            <router-link :to="{name: 'home'}">
                Back to Home
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFound404',
};
</script>
